import { apiServer } from 'settings/web-services/api';

export function getServicesCategoriesList(cfg) {
  return apiServer.get('/concierge/categories', cfg);
}
